import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/menu/首页蓝.png';
import _imports_1 from '@/assets/menu/首页.png';
import _imports_2 from '@/assets/menu/当日考勤蓝.png';
import _imports_3 from '@/assets/menu/当日考勤.png';
import _imports_4 from '@/assets/menu/排课调课蓝.png';
import _imports_5 from '@/assets/menu/排课调课.png';
import _imports_6 from '@/assets/menu/报名与课消蓝.png';
import _imports_7 from '@/assets/menu/报名与课消.png';
import _imports_8 from '@/assets/menu/财务蓝色.png';
import _imports_9 from '@/assets/menu/财务白色.png';
import _imports_10 from '@/assets/menu/课时统计蓝.png';
import _imports_11 from '@/assets/menu/课时统计.png';
import _imports_12 from '@/assets/menu/人员设置蓝.png';
import _imports_13 from '@/assets/menu/人员设置.png';
const _hoisted_1 = {
  id: "app",
  style: {
    "height": "1080px",
    "width": "1920px",
    "border": "none",
    "overflow": "hidden",
    "position": "relative"
  }
};
const _hoisted_2 = {
  id: "showAfterLogin",
  style: {
    "position": "absolute",
    "top": "0",
    "right": "0",
    "background": "#fbfbfb",
    "height": "90px",
    "width": "970px"
  }
};
const _hoisted_3 = {
  style: {
    "height": "100%",
    "width": "100%",
    "display": "flex",
    "justify-content": "right",
    "padding": "25px 60px 0 0"
  }
};
const _hoisted_4 = {
  key: 1,
  style: {
    "margin": "0px 0 0 40px"
  }
};
const _hoisted_5 = {
  style: {
    "line-height": "1.5"
  }
};
const _hoisted_6 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_7 = {
  style: {
    "margin": "0px 0 0 20px",
    "height": "52px",
    "width": "52px",
    "border-radius": "10px",
    "background": "grey",
    "font-size": "34px",
    "font-weight": "bold",
    "color": "white",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_8 = {
  key: 0,
  style: {
    "margin": "0px 0 0 10px",
    "height": "52px",
    "display": "flex",
    "justify-content": "center",
    "flex-direction": "column"
  }
};
const _hoisted_9 = {
  style: {
    "text-align": "left",
    "font-size": "18px"
  }
};
const _hoisted_10 = {
  key: 0,
  style: {
    "margin": "0px 0 0 0px",
    "text-align": "left",
    "font-size": "16px"
  }
};
const _hoisted_11 = {
  key: 0,
  style: {
    "height": "1080px",
    "width": "1920px",
    "border": "none",
    "overflow": "hidden",
    "position": "absolute",
    "top": "0",
    "left": "0"
  }
};
const _hoisted_12 = {
  style: {
    "width": "100%",
    "display": "flex",
    "justify-content": "center",
    "font-size": "30px",
    "font-weight": "bold",
    "color": "red",
    "margin": "20px 0 0 0"
  }
};
const _hoisted_13 = {
  id: "menu",
  style: {
    "height": "690px",
    "width": "310px",
    "background": "#fbfbfb",
    "border": "none",
    "position": "absolute",
    "top": "0",
    "left": "0",
    "margin": "161px 0 0 0px",
    "overflow-y": "auto",
    "overflow-x": "hidden"
  }
};
const _hoisted_14 = {
  key: 0,
  src: _imports_0
};
const _hoisted_15 = {
  key: 1,
  src: _imports_1
};
const _hoisted_16 = {
  key: 0,
  src: _imports_2
};
const _hoisted_17 = {
  key: 1,
  src: _imports_3
};
const _hoisted_18 = {
  key: 2,
  style: {
    "position": "absolute",
    "top": "0",
    "left": "0",
    "margin": "13px 0 0 175px",
    "background": "red",
    "color": "white",
    "height": "30px",
    "width": "30px",
    "border-radius": "50%",
    "font-size": "20px",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_19 = {
  key: 0,
  src: _imports_4
};
const _hoisted_20 = {
  key: 1,
  src: _imports_5
};
const _hoisted_21 = {
  key: 2,
  style: {
    "position": "absolute",
    "top": "0",
    "left": "0",
    "margin": "13px 0 0 190px",
    "background": "red",
    "color": "white",
    "height": "30px",
    "width": "30px",
    "border-radius": "50%",
    "font-size": "20px",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_22 = {
  key: 0,
  style: {
    "width": "310px",
    "color": "grey",
    "margin": "0px 0 0 0",
    "border": "none"
  }
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = {
  key: 0,
  style: {
    "color": "#0d2f89",
    "background": "#edf1fb",
    "padding": "0 0 0 100px"
  }
};
const _hoisted_25 = {
  key: 1,
  style: {
    "padding": "0 0 0 100px"
  }
};
const _hoisted_26 = {
  key: 2,
  style: {
    "position": "absolute",
    "top": "0",
    "left": "0",
    "margin": "6px 0 0 190px",
    "background": "red",
    "color": "white",
    "height": "30px",
    "width": "30px",
    "border-radius": "50%",
    "font-size": "20px",
    "font-weight": "300",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_27 = {
  key: 0,
  src: _imports_6
};
const _hoisted_28 = {
  key: 1,
  src: _imports_7
};
const _hoisted_29 = {
  key: 2,
  style: {
    "position": "absolute",
    "top": "0",
    "left": "0",
    "margin": "13px 0 0 190px",
    "background": "red",
    "color": "white",
    "height": "30px",
    "width": "30px",
    "border-radius": "50%",
    "font-size": "20px",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_30 = {
  key: 1,
  style: {
    "width": "310px",
    "color": "grey",
    "margin": "0px 0 0 0",
    "border": "none"
  }
};
const _hoisted_31 = ["onClick"];
const _hoisted_32 = {
  key: 0,
  style: {
    "height": "40px",
    "width": "310px",
    "line-height": "40px",
    "font-size": "16px",
    "font-weight": "bold",
    "margin": "0px 0 0 0",
    "border": "none",
    "position": "relative"
  }
};
const _hoisted_33 = {
  key: 0,
  style: {
    "color": "#0d2f89",
    "background": "#edf1fb",
    "padding": "0 0 0 100px"
  }
};
const _hoisted_34 = {
  key: 1,
  style: {
    "padding": "0 0 0 100px"
  }
};
const _hoisted_35 = {
  key: 2,
  style: {
    "position": "absolute",
    "top": "0",
    "left": "0",
    "margin": "6px 0 0 190px",
    "background": "red",
    "color": "white",
    "height": "30px",
    "width": "30px",
    "border-radius": "50%",
    "font-size": "20px",
    "font-weight": "300",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_36 = {
  key: 0,
  src: _imports_8
};
const _hoisted_37 = {
  key: 1,
  src: _imports_9
};
const _hoisted_38 = {
  key: 2,
  style: {
    "position": "absolute",
    "top": "0",
    "left": "0",
    "margin": "13px 0 0 175px",
    "background": "red",
    "color": "white",
    "height": "30px",
    "width": "30px",
    "border-radius": "50%",
    "font-size": "20px",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_39 = {
  key: 3,
  style: {
    "width": "310px",
    "color": "grey",
    "margin": "0px 0 0 0",
    "border": "none"
  }
};
const _hoisted_40 = ["onClick"];
const _hoisted_41 = {
  key: 0,
  style: {
    "color": "#0d2f89",
    "background": "#edf1fb",
    "padding": "0 0 0 100px"
  }
};
const _hoisted_42 = {
  key: 1,
  style: {
    "padding": "0 0 0 100px"
  }
};
const _hoisted_43 = {
  key: 2,
  style: {
    "position": "absolute",
    "top": "0",
    "left": "0",
    "margin": "5px 0 0 175px",
    "background": "red",
    "color": "white",
    "height": "30px",
    "width": "30px",
    "border-radius": "50%",
    "font-size": "20px",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_44 = {
  key: 0,
  src: _imports_10
};
const _hoisted_45 = {
  key: 1,
  src: _imports_11
};
const _hoisted_46 = {
  key: 0,
  src: _imports_12
};
const _hoisted_47 = {
  key: 1,
  src: _imports_13
};
const _hoisted_48 = {
  style: {
    "height": "220px",
    "width": "900px",
    "overflow-y": "auto"
  }
};
const _hoisted_49 = {
  style: {
    "display": "inline-block",
    "vertical-align": "top",
    "width": "200px",
    "text-align": "center",
    "border-bottom": "1px solid #ededed"
  }
};
const _hoisted_50 = {
  style: {
    "display": "inline-block",
    "vertical-align": "top",
    "width": "200px",
    "text-align": "center",
    "border-bottom": "1px solid #ededed"
  }
};
const _hoisted_51 = {
  style: {
    "display": "inline-block",
    "vertical-align": "top",
    "width": "200px",
    "text-align": "center",
    "border-bottom": "1px solid #ededed"
  }
};
const _hoisted_52 = {
  style: {
    "display": "inline-block",
    "vertical-align": "top",
    "width": "200px",
    "text-align": "center",
    "border-bottom": "1px solid #ededed"
  }
};
const _hoisted_53 = {
  style: {
    "display": "inline-block",
    "vertical-align": "top",
    "width": "200px",
    "text-align": "center",
    "border-bottom": "1px solid #ededed"
  }
};
const _hoisted_54 = {
  key: 1,
  style: {
    "height": "1080px",
    "width": "1920px",
    "position": "absolute",
    "top": "0",
    "left": "0",
    "backdrop-filter": "blur(5px)",
    "overflow": "hidden"
  }
};
const _hoisted_55 = {
  style: {
    "min-height": "270px",
    "width": "720px",
    "margin": "340px 0 0 600px",
    "position": "absolute",
    "top": "0",
    "left": "0",
    "background": "white",
    "border-radius": "10px",
    "box-shadow": "#666 0px 0px 10px",
    "overflow": "hidden",
    "display": "flex",
    "justify-content": "center",
    "flex-direction": "column"
  }
};
const _hoisted_56 = {
  style: {
    "width": "100%",
    "margin": "30px 0 0 0px",
    "background": "white",
    "font-size": "30px",
    "font-weight": "bold",
    "text-align": "center"
  }
};
const _hoisted_57 = {
  style: {
    "width": "100%",
    "margin": "30px 0 30px 0",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_58 = {
  key: 2,
  style: {
    "height": "1080px",
    "width": "1920px",
    "position": "absolute",
    "top": "0",
    "left": "0",
    "backdrop-filter": "blur(5px)",
    "overflow": "hidden"
  }
};
const _hoisted_59 = {
  style: {
    "min-height": "270px",
    "width": "520px",
    "margin": "340px 0 0 700px",
    "position": "absolute",
    "top": "0",
    "left": "0",
    "background": "white",
    "border-radius": "10px",
    "box-shadow": "#666 0px 0px 10px",
    "overflow": "hidden",
    "display": "flex",
    "justify-content": "center",
    "flex-direction": "column"
  }
};
const _hoisted_60 = {
  style: {
    "margin": "0 0 0 37px"
  }
};
const _hoisted_61 = {
  style: {
    "width": "100%",
    "margin": "30px 0 30px 0",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_62 = {
  key: 3,
  style: {
    "height": "1080px",
    "width": "1920px",
    "position": "absolute",
    "top": "0",
    "left": "0",
    "background": "#fbfbfb"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_el_input = _resolveComponent("el-input");
  const _component_test = _resolveComponent("test");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_view, {
    onRefundApproval: $options.refundApproval,
    onUpdateVariable: $options.updateVariable
  }, null, 8, ["onRefundApproval", "onUpdateVariable"]), _createElementVNode("div", _hoisted_2, [_cache[22] || (_cache[22] = _createElementVNode("div", {
    style: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "margin": "865px 0 0 -910px",
      "background": "#fbfbfb",
      "border": "none",
      "height": "170px",
      "width": "170px"
    }
  }, null, -1)), _createElementVNode("div", _hoisted_3, [$data.showApplyTestRecordsButton ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    id: "",
    style: {
      "height": "52px",
      "width": "150px",
      "font-size": "17px",
      "color": "#0d2f89",
      "border": "2px solid #0d2f89",
      "border-radius": "15px",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    },
    onmouseover: "this.style.cursor='pointer'",
    onMouseover: _cache[0] || (_cache[0] = $event => $options.clickShowApplyTestRecords())
  }, " 申请试用记录 ", 32)) : _createCommentVNode("", true), $data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_tooltip, {
    placement: "bottom"
  }, {
    content: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createTextVNode(" 用户名: " + _toDisplayString($data.userInfo.name), 1), _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)), _createTextVNode(" 手机号: " + _toDisplayString($data.userInfo.phone), 1), _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)), _createTextVNode(" 职位: " + _toDisplayString($data.userInfo.position), 1), _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)), _createTextVNode(" 机构: " + _toDisplayString($data.userInfo.institution), 1)])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString($data.userInfo.nameFirstLetter), 1), $data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString($data.username), 1), $data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($data.userInfo.position), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]),
    _: 1
  })])) : _createCommentVNode("", true), _createElementVNode("div", {
    style: {
      "margin": "0px 0 0 40px",
      "height": "52px",
      "width": "100px",
      "font-size": "17px",
      "color": "#0d2f89",
      "border": "2px solid #0d2f89",
      "border-radius": "15px",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    },
    onClick: _cache[1] || (_cache[1] = (...args) => $options.modifyPassword && $options.modifyPassword(...args)),
    onmouseover: "this.style.cursor='pointer'"
  }, " 修改密码 "), _createElementVNode("div", {
    style: {
      "margin": "0px 0 0 40px",
      "height": "52px",
      "width": "100px",
      "font-size": "17px",
      "color": "#0d2f89",
      "border": "2px solid #0d2f89",
      "border-radius": "15px",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    },
    onClick: _cache[2] || (_cache[2] = (...args) => $options.logout && $options.logout(...args)),
    onmouseover: "this.style.cursor='pointer'"
  }, " 退出登录 ")])]), $data.userInfo && !$data.userInfo.roles.includes('编辑') ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_cache[23] || (_cache[23] = _createTextVNode(" 仅查看，无编辑权限，请联系管理员", -1)), _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)), _createTextVNode(_toDisplayString($data.userInfo.adminInfo.name) + " " + _toDisplayString($data.userInfo.adminInfo.phone), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
    style: {
      "height": "55px",
      "width": "310px",
      "margin": "0px 0 0 0",
      "border": "none"
    },
    onmouseover: "this.style.cursor='pointer'",
    onClick: _cache[3] || (_cache[3] = $event => $options.clickMenu(1))
  }, [$data.menuIndex == 1 ? (_openBlock(), _createElementBlock("img", _hoisted_14)) : _createCommentVNode("", true), $data.menuIndex != 1 ? (_openBlock(), _createElementBlock("img", _hoisted_15)) : _createCommentVNode("", true)]), _createElementVNode("div", {
    style: {
      "height": "55px",
      "width": "310px",
      "margin": "9px 0 0 0",
      "border": "none",
      "position": "relative"
    },
    onmouseover: "this.style.cursor='pointer'",
    onClick: _cache[4] || (_cache[4] = $event => $options.clickMenu(2))
  }, [$data.menuIndex == 2 ? (_openBlock(), _createElementBlock("img", _hoisted_16)) : _createCommentVNode("", true), $data.menuIndex != 2 ? (_openBlock(), _createElementBlock("img", _hoisted_17)) : _createCommentVNode("", true), $data.pendingCheckInDate.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString($data.pendingCheckInDate.length), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", {
    style: {
      "height": "55px",
      "width": "310px",
      "margin": "9px 0 0 0",
      "border": "none",
      "position": "relative"
    },
    onmouseover: "this.style.cursor='pointer'",
    onClick: _cache[5] || (_cache[5] = $event => $options.clickMenu(3))
  }, [$data.menuIndex == 3 ? (_openBlock(), _createElementBlock("img", _hoisted_19)) : _createCommentVNode("", true), $data.menuIndex != 3 ? (_openBlock(), _createElementBlock("img", _hoisted_20)) : _createCommentVNode("", true), $data.needArrangeCourseClassIds.length > 0 && $data.menuIndex != 3 ? (_openBlock(), _createElementBlock("div", _hoisted_21, " ! ")) : _createCommentVNode("", true)]), $data.menuIndex == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.menu3SubTitles, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      style: {
        "height": "40px",
        "width": "310px",
        "line-height": "40px",
        "font-size": "16px",
        "font-weight": "bold",
        "margin": "5px 0 0 0",
        "border": "none",
        "position": "relative"
      },
      onmouseover: "this.style.cursor='pointer'",
      onClick: $event => $options.clickSubMenu(3, index + 1)
    }, [$data.menu3SubIndex == index + 1 ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString($data.menu3SubTitles[index]), 1)) : _createCommentVNode("", true), $data.menu3SubIndex != index + 1 ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString($data.menu3SubTitles[index]), 1)) : _createCommentVNode("", true), $data.needArrangeCourseClassIds.length > 0 && index == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_26, " ! ")) : _createCommentVNode("", true)], 8, _hoisted_23);
  }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", {
    style: {
      "height": "55px",
      "width": "310px",
      "margin": "9px 0 0 0",
      "border": "none",
      "position": "relative"
    },
    onmouseover: "this.style.cursor='pointer'",
    onClick: _cache[6] || (_cache[6] = $event => $options.clickMenu(4))
  }, [$data.menuIndex == 4 ? (_openBlock(), _createElementBlock("img", _hoisted_27)) : _createCommentVNode("", true), $data.menuIndex != 4 ? (_openBlock(), _createElementBlock("img", _hoisted_28)) : _createCommentVNode("", true), $data.pendingDealStudentIds.length > 0 && $data.menuIndex != 4 ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString($data.pendingDealStudentIds.length), 1)) : _createCommentVNode("", true)]), $data.menuIndex == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_30, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.menu4SubTitles, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      style: {
        "width": "310px",
        "font-size": "16px",
        "font-weight": "bold",
        "margin": "8px 0 0 0",
        "border": "none",
        "position": "relative"
      },
      onmouseover: "this.style.cursor='pointer'",
      onClick: $event => $options.clickSubMenu(4, index + 1)
    }, [index != 2 || $data.userInfo && $data.userInfo.roles.includes('交易记录') ? (_openBlock(), _createElementBlock("div", _hoisted_32, [$data.menu4SubIndex == index + 1 ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString($data.menu4SubTitles[index]), 1)) : _createCommentVNode("", true), $data.menu4SubIndex != index + 1 ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString($data.menu4SubTitles[index]), 1)) : _createCommentVNode("", true), $data.pendingDealStudentIds.length > 0 && index == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString($data.pendingDealStudentIds.length), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 8, _hoisted_31);
  }), 128))])) : _createCommentVNode("", true), $data.userInfo && $data.userInfo.roles.includes('财务') ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    style: {
      "height": "55px",
      "width": "310px",
      "margin": "9px 0 0 0",
      "border": "none",
      "position": "relative"
    },
    onmouseover: "this.style.cursor='pointer'",
    onClick: _cache[7] || (_cache[7] = $event => $options.clickMenu(5))
  }, [$data.menuIndex == 5 ? (_openBlock(), _createElementBlock("img", _hoisted_36)) : _createCommentVNode("", true), $data.menuIndex != 5 ? (_openBlock(), _createElementBlock("img", _hoisted_37)) : _createCommentVNode("", true), $data.pendingRefundApplyNumber > 0 && $data.menuIndex != 5 ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString($data.pendingRefundApplyNumber), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.menuIndex == 5 ? (_openBlock(), _createElementBlock("div", _hoisted_39, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.menu5SubTitles, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      style: {
        "height": "40px",
        "width": "310px",
        "line-height": "40px",
        "font-size": "16px",
        "font-weight": "bold",
        "margin": "8px 0 0 0",
        "border": "none",
        "position": "relative"
      },
      onmouseover: "this.style.cursor='pointer'",
      onClick: $event => $options.clickSubMenu(5, index + 1)
    }, [$data.menu5SubIndex == index + 1 ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString($data.menu5SubTitles[index]), 1)) : _createCommentVNode("", true), $data.menu5SubIndex != index + 1 ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString($data.menu5SubTitles[index]), 1)) : _createCommentVNode("", true), $data.menu5SubTitles[index] == '退费审核' && $data.pendingRefundApplyNumber > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString($data.pendingRefundApplyNumber), 1)) : _createCommentVNode("", true)], 8, _hoisted_40);
  }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", {
    style: {
      "height": "55px",
      "width": "310px",
      "margin": "9px 0 0 0",
      "border": "none"
    },
    onmouseover: "this.style.cursor='pointer'",
    onClick: _cache[8] || (_cache[8] = $event => $options.clickMenu(6))
  }, [$data.menuIndex == 6 ? (_openBlock(), _createElementBlock("img", _hoisted_44)) : _createCommentVNode("", true), $data.menuIndex != 6 ? (_openBlock(), _createElementBlock("img", _hoisted_45)) : _createCommentVNode("", true)]), $data.userInfo && $data.userInfo.roles.includes('人员设置') ? (_openBlock(), _createElementBlock("div", {
    key: 4,
    style: {
      "height": "55px",
      "width": "310px",
      "margin": "9px 0 0 0",
      "border": "none"
    },
    onmouseover: "this.style.cursor='pointer'",
    onClick: _cache[9] || (_cache[9] = $event => $options.clickMenu(7))
  }, [$data.menuIndex == 7 ? (_openBlock(), _createElementBlock("img", _hoisted_46)) : _createCommentVNode("", true), $data.menuIndex != 7 ? (_openBlock(), _createElementBlock("img", _hoisted_47)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("div", {
    style: {
      "width": "900px",
      "position": "absolute",
      "top": "0",
      "right": "410px",
      "margin": "25px 0 0 0",
      "box-shadow": "#666 0px 0px 10px",
      "border-radius": "15px",
      "background": "white"
    },
    onMouseleave: _cache[10] || (_cache[10] = $event => $options.cancelShowApplyTestRecords())
  }, [_cache[25] || (_cache[25] = _createStaticVNode("<div style=\"height:70px;line-height:70px;margin:0px 0 0 30px;font-size:24px;font-weight:bold;display:flex;\"> 最近两个月的申请试用记录 </div><div style=\"height:70px;line-height:70px;width:100%;font-size:18px;font-weight:bold;white-space:nowrap;display:flex;border-top:1px solid #ededed;\"><div style=\"display:inline-block;vertical-align:top;width:200px;text-align:center;border-bottom:1px solid #ededed;\"> 机构 </div><div style=\"display:inline-block;vertical-align:top;width:200px;text-align:center;border-bottom:1px solid #ededed;\"> 区域 </div><div style=\"display:inline-block;vertical-align:top;width:200px;text-align:center;border-bottom:1px solid #ededed;\"> 姓名 </div><div style=\"display:inline-block;vertical-align:top;width:200px;text-align:center;border-bottom:1px solid #ededed;\"> 手机号 </div><div style=\"display:inline-block;vertical-align:top;width:200px;text-align:center;border-bottom:1px solid #ededed;\"> 申请时间 </div></div>", 2)), _createElementVNode("div", _hoisted_48, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.applyTestRecords, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      style: {
        "height": "60px",
        "line-height": "60px",
        "font-size": "16px",
        "white-space": "nowrap",
        "display": "flex"
      }
    }, [_createElementVNode("div", _hoisted_49, _toDisplayString(item.institution), 1), _createElementVNode("div", _hoisted_50, _toDisplayString(item.province) + "," + _toDisplayString(item.city) + "," + _toDisplayString(item.area), 1), _createElementVNode("div", _hoisted_51, _toDisplayString(item.username), 1), _createElementVNode("div", _hoisted_52, _toDisplayString(item.phone), 1), _createElementVNode("div", _hoisted_53, _toDisplayString(item.create_time), 1)]);
  }), 128))])], 544), [[_vShow, $data.showApplyTestRecords]]), $data.showTip ? (_openBlock(), _createElementBlock("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, _toDisplayString($data.tipMessage), 1), $data.tipNeedInput ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
    key: 0,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.tipInputText = $event),
    style: {
      "min-height": "100px",
      "width": "620px",
      "margin": "30px 0 0 50px",
      "font-size": "20px"
    }
  }, null, 512)), [[_vModelText, $data.tipInputText]]) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", {
    style: {
      "height": "50px",
      "width": "170px",
      "font-size": "20px",
      "border-radius": "10px",
      "background": "#1b48bb",
      "color": "white",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    },
    onClick: _cache[12] || (_cache[12] = $event => $options.confirmTip()),
    onmouseover: "this.style.cursor='pointer'"
  }, " 确定 "), _createElementVNode("div", {
    style: {
      "height": "50px",
      "width": "170px",
      "font-size": "20px",
      "color": "#0091ff",
      "border": "1px solid #0091ff",
      "border-radius": "10px",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "margin": "0px 0 0 20px"
    },
    onClick: _cache[13] || (_cache[13] = $event => $options.closeTip()),
    onmouseover: "this.style.cursor='pointer'"
  }, " 取消 ")])])])) : _createCommentVNode("", true), $data.showModifyPassword ? (_openBlock(), _createElementBlock("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_cache[29] || (_cache[29] = _createElementVNode("div", {
    style: {
      "width": "100%",
      "margin": "30px 0 0 0px",
      "background": "white",
      "font-size": "30px",
      "font-weight": "bold",
      "text-align": "center"
    }
  }, " 修改密码 ", -1)), _createElementVNode("div", _hoisted_60, [_cache[26] || (_cache[26] = _createElementVNode("div", {
    style: {
      "font-size": "20px"
    }
  }, "原密码", -1)), _createVNode(_component_el_input, {
    class: "searchInput",
    style: {
      "height": "50px",
      "width": "446px",
      "text-align": "center",
      "font-size": "22px",
      "font-weight": "bold",
      "margin": "10px 0 0 0px",
      "background": "white"
    },
    modelValue: $data.formerPassword,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.formerPassword = $event),
    placeholder: "请输入原密码"
  }, null, 8, ["modelValue"]), _cache[27] || (_cache[27] = _createElementVNode("div", {
    style: {
      "font-size": "20px",
      "margin": "20px 0 0 0"
    }
  }, "新密码", -1)), _createVNode(_component_el_input, {
    class: "searchInput",
    style: {
      "height": "50px",
      "width": "446px",
      "text-align": "center",
      "font-size": "22px",
      "font-weight": "bold",
      "margin": "10px 0 0 0px",
      "background": "white"
    },
    modelValue: $data.newPassword,
    "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.newPassword = $event),
    placeholder: "请输入新密码"
  }, null, 8, ["modelValue"]), _cache[28] || (_cache[28] = _createElementVNode("div", {
    style: {
      "font-size": "20px",
      "margin": "20px 0 0 0"
    }
  }, "再次确认新密码", -1)), _createVNode(_component_el_input, {
    class: "searchInput",
    style: {
      "height": "50px",
      "width": "446px",
      "text-align": "center",
      "font-size": "22px",
      "font-weight": "bold",
      "margin": "10px 0 0 0px",
      "background": "white"
    },
    modelValue: $data.confirmNewPassword,
    "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.confirmNewPassword = $event),
    placeholder: "请再次输入新密码"
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_61, [_createElementVNode("div", {
    style: {
      "height": "50px",
      "width": "170px",
      "font-size": "20px",
      "border-radius": "10px",
      "background": "#1b48bb",
      "color": "white",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    },
    onClick: _cache[17] || (_cache[17] = $event => $options.modifyPasswordConfirm()),
    onmouseover: "this.style.cursor='pointer'"
  }, " 确定 "), _createElementVNode("div", {
    style: {
      "height": "50px",
      "width": "170px",
      "font-size": "20px",
      "color": "#0091ff",
      "border": "1px solid #0091ff",
      "border-radius": "10px",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "margin": "0px 0 0 20px"
    },
    onClick: _cache[18] || (_cache[18] = $event => $options.modifyPasswordCancel()),
    onmouseover: "this.style.cursor='pointer'"
  }, " 取消 ")])])])) : _createCommentVNode("", true), $data.routePath == 'test' ? (_openBlock(), _createElementBlock("div", _hoisted_62, [_createVNode(_component_test)])) : _createCommentVNode("", true)]);
}